export default {
  id: {
    label: 'ID',
    width: 100
  },
  name: {
    label: '设备名称',
    width: 180,
    sort: true,
    filter: {
      type: 'input',
      like: true,
      width: 100
    },
    form: {
      type: 'input',
      // size: 10,
      rules: [{
        type: 'required',
        message: '请输入设备名称'
      }]
    }
  },
  code: {
    label: '设备编号',
    width: 150,
    sort: true,
    filter: {
      type: 'input',
      like: true,
      width: 100
    },
    form: {
      type: 'input',
      size: 12,
      rules: [{ type: 'required', message: '请输入设备编号' },
        {type: 'alphaNum', message: '输入正确设备编号，允许英文、数字'}]
    }
  },
  areaId: {
    label: '计量器区域',
    relation: 'areaId',
    type: 'select',
    width: 150,
    filter: {
      type: 'cascader',
      onlySelectLeaf: false,
      width: 120
    },
    form: {
      type: 'cascader',
      onlySelectLeaf: false,
      size: 10,
      rules: [{ type: 'required', message: '请选择对应的区域' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  payloadTypeId: {
    label: '设备类型',
    type: 'select',
    relation: 'counterTypeId',
    width: 200,
    minLength: 300,
    filter: {
      type: 'select',
      width: 150
    },
    form: {
      type: 'select',
      size: 10,
      rules: [{
        type: 'required',
        message: '请选择设备类型'
      }]
    }
  },
  countersAll: {
    label: '所有计量器设备',
    width: 100,
    relation: 'countersAll'
  },
  typeName: {
    label: '设备类型名称',
    width: 100
  },
  createTime: {
    label: '创建时间',
    type: 'time',
    width: 200,
    sort: 'desc',
    dataType: 'YYYY-MM-DD HH:mm:ss',
    style: {
      'text-align': 'center'
    },
    filter: {
      type: 'daterange',
      width: 200,
      live: true
    },
    form: {
      type: 'date',
      rules: [
        { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
      ]
    }
  },
  time: {
    label: '读表时间',
    type: 'time',
    width: 250,
    size: 8,
    dataType: 'YYYY-MM-DD',
    filter: {
      type: 'daterange'
    },
    form: {
      type: 'date',
      rules: [
        { type: 'number', required: true, message: '请选择开始时间', trigger: 'change' }
      ]
    }
  },
  creatorId: {
    label: '创建者',
    width: 120,
    type: 'select',
    relation: 'users'
    // relation: 'users',
  },
  totalData: {
    label: '总水量',
    width: 200,
    style: {
      'text-align': 'center'
    }
  },
  port: {
    label: '设备端口号',
    width: 120,
    textAlign: 'center',
    style: {
      'text-align': 'center'
    },
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'required', message: '请输入设备端口号' },
      { type: 'numeric', message: '只允许输入数字' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  baudrate: {
    label: '波特率',
    width: 100,
    style: {
      'text-align': 'center'
    },
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'required', message: '请输入波特率' },
      { type: 'numeric', message: '只允许输入数字' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  rateNumber: {
    label: '费率个数',
    width: 100,
    style: {
      textAlign: 'center'
    },
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numeric', message: '只允许输入数字' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  electric: {
    label: '电能',
    width: 100,
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numfloat', message: '只允许输入整数、浮点数' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    },
    style: {
      textAlign: 'center'
    }
  },
  largeType: {
    label: '大类号',
    width: 100,
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numeric', message: '只允许输入数字' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  smallType: {
    label: '  小类号',
    width: 100,
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numeric', message: '只允许输入数字' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  deviceType: {
    label: '仪表类型',
    width: 100,
    // relation: 'deviceType',
    form: {
      type: 'input',
      size: 10,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  collectorId: {
    label: '所属采集器',
    width: 200,
    type: 'select',
    sort: true,
    relation: 'collectorsAll',
    filter: {
      type: 'select',
      width: 120
    },
    form: {
      type: 'select',
      rules: [{ type: 'required', message: '请选择所属采集器' }],
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  // 采集器
  collectorName: {
    label: '采集器',
    width: 150,
    sort: true
  },
  collectorCode: {
    label: '采集器编号',
    width: 150,
    sort: true,
    form: {
      type: 'input',
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  collectorPayloadTypeId: {
    label: '采集器类型',
    width: 200,
    relation: 'collectorTypeId',
    type: 'select',
    filter: {
      type: 'select',
      width: 200
    }
  },
  collectorTypeId: {
    label: '采集器类型',
    width: 200,
    relation: 'collectorTypeId',
    type: 'select',
    filter: {
      type: 'select',
      width: 200
    }
  },
  // 中继器
  repeaterId: {
    label: '中继器',
    width: 150,
    form: {
      type: 'select',
      size: 10,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  repeaterCode: {
    label: '中继器编号',
    width: 150,
    form: {
      type: 'input',
      size: 10,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  repeaterType: {
    label: '中继器类型',
    width: 120,
    type: 'select',
    relation: 'repeaterTypeId',
    form: {
      type: 'select',
      size: 10,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  hno: {
    label: '户号',
    type: 'input',
    width: 110,
    filter: {
      type: 'input',
      width: 100,
      like: true
    },
    form: {
      type: 'input',
      size: 10,
      columnSize: [{
        type: 'md',
        size: 6
      }, {
        type: 'sm',
        size: 12
      }]
    }
  },
  hname: {
    label: '户名',
    type: 'input',
    size: 6,
    width: 100,
    filter: {
      type: 'input',
      width: 100,
      like: true
    },
    form: {
      type: 'input',
      size: 10
    }
  },
  addr: {
    label: '地址',
    width: 200,
    size: 16,
    labelSize: 4,
    isWrap: true,
    form: {
      type: 'text',
      size: 24
    }
  },
  phone: {
    label: '固话',
    size: 8,
    width: 120,
    form: {
      type: 'input',
      size: 10
    }
  },
  mobile: {
    label: '联系手机',
    size: 8,
    width: 200,
    form: {
      type: 'input',
      size: 10,
      rules: [{ type: 'numeric', message: '输入正确的手机号' }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/TelnetReading/columns.js